import FormPage from 'routes/ReferralForm/FormView/components/FormPage/FormPage';

export default FormPage;
